<template>
  <div>
    <masonry-wall
      class="masonry-grid-item"
      :items="offerRequests"
      :column-width="250"
      :gap="20"
    >
      <template #default="{ item: offerRequest, index }">
        <div class="grid-item w-full">
          <offer-request-list-view-item
            :guest="guest"
            :offer-request="offerRequest"
            :active-offer-request="activeOfferRequest"
            :index="index"
            :lang="lang"
            :contacted="contactedOfferRequestIds.has(offerRequest.id)"
            @show-register-modal="loadRegisterModal"
            @send-msg="handleSendMsg"
          ></offer-request-list-view-item>
        </div>
      </template>
    </masonry-wall>

    <modal-master-user
      v-if="!guest"
      ref="modalMasterUser"
      @msg-sent="handleMsgSent"
    ></modal-master-user>

    <modal-master-guest ref="modalMasterGuest"></modal-master-guest>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import OfferRequestListViewItem from "./OfferRequestListViewItem.vue";
import ModalMasterUser from "../modal/ModalMasterUser.vue";
import ModalMasterGuest from "../modal/ModalMasterGuest.vue";

// COMPONENT PROPS
const props = defineProps({
  guest: Boolean,
  initOfferRequests: Array,
  activeOfferRequest: {
    type: Number,
    default: 0,
  },
  lang: Object,
});

// TEMPLATE REFS
const modalMasterUser = ref(null);
const modalMasterGuest = ref(null);

// COMPONENT DATA
const offerRequests = ref(props.initOfferRequests);
const contactedOfferRequestIds = reactive(new Set());
const currentOfferRequest = ref(null);

// METHODS

/**
 * scroll and hightlight active offer request item
 */
const scrollToActiveOfferRequest = () => {
  if (props.activeOfferRequest === 0) {
    return;
  }

  // scroll to item
  setTimeout(() => {
    const element = document.getElementById(`item${props.activeOfferRequest}`);

    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }, 500);
};

/**
 * handle send message from offer request item
 */
const handleSendMsg = (offerRequest) => {
  currentOfferRequest.value = offerRequest;
  modalMasterUser.value.loadModal("offerRequestMsg", { offerRequest });
};

/**
 * handle message sent confirmation
 */
const handleMsgSent = () => {
  contactedOfferRequestIds.add(currentOfferRequest.value.id);
};

/**
 * load register modal
 */
const loadRegisterModal = () => {
  const modalData = {
    modalTrigger: "offerRequestMsg",
  };

  modalMasterGuest.value.loadModal("guestRegister", modalData);
};

// LIFECYCLE HOOKS
onMounted(() => {
  scrollToActiveOfferRequest();
});
</script>

<style scoped>
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .masonry-grid-item {
    margin-left: auto;
    margin-right: auto;
    max-width: 525px;
  }
}

/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .masonry-grid-item {
    margin-left: auto;
    margin-right: auto;
    max-width: 795px;
  }
}

/* Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .masonry-grid-item {
    margin-left: auto;
    margin-right: auto;
    max-width: 1060px;
  }
}
</style>
